<template>
  <section-collapseable
    default-expanded
    hide-initial-always
  >
    <template v-slot:expanded>
      <record-deal></record-deal>
    </template>
  </section-collapseable>
</template>

<script>
import RecordDeal from "../components/RecordDeal";
export default {
  name: "LeadDeal",
  components: {RecordDeal},
}
</script>
